import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
import Link from 'redux-first-router-link'
import * as logos from '@groovehq/internal-design-system/lib/assets/icons/logos'
import { SETTINGS_INTEGRATIONS_PAGE } from 'subapps/settings/types'
import { selectAccount } from 'selectors/app'
import { propFunc } from 'util/functions'
import { selectCurrentUserIsAdminOrOwner } from 'ducks/currentUser'
import selectIntegrationData from 'ducks/integrations/selectors/settings/selectIntegrationData'
import ButtonWithMenu from '../ButtonWithMenu'
import { integrationGroup } from './data'
import { styles } from './styles'

const toIntegrationsPage = {
  type: SETTINGS_INTEGRATIONS_PAGE,
}

const activeColor = 'color.monochrome.superLight'

const Menu = ({ handleClickIntegration, onClose }) => {
  const { industry } = useSelector(selectAccount)
  const isManager = useSelector(selectCurrentUserIsAdminOrOwner)
  const integrationData = useSelector(selectIntegrationData)

  const integrationList = useMemo(
    () => {
      const integrationsConfig =
        integrationGroup[industry] || integrationGroup.Other
      return integrationsConfig?.filter(item => {
        const config = integrationData.find(i => i.id === item.id)
        // eslint-disable-next-line no-param-reassign
        item.logo = config.logo
        // eslint-disable-next-line no-param-reassign
        item.name = config.name
        return config.isAdminOnly ? isManager : true
      })
    },
    [industry, integrationData, isManager]
  )

  const footer = (
    <Link to={toIntegrationsPage} className="grui underline" onClick={onClose}>
      <strong>See all 25+ integrations to supercharge your account.</strong>
    </Link>
  )

  return (
    <ButtonWithMenu.Menu footer={footer} css={styles.menu}>
      {integrationList?.map(item => {
        const Logo = logos[item.logo]
        return (
          <ButtonWithMenu.Menu.Item
            icon={<Logo className={item.iconCls || 'sm-icon'} />}
            title={item.name}
            copy={item.copy}
            onClick={propFunc(handleClickIntegration, item.id)}
            activeColor={activeColor}
            key={item.id}
          />
        )
      })}
    </ButtonWithMenu.Menu>
  )
}

export default Menu
